<template>
  <div id="mark-ad-select">
    <Multiselect v-model="val" @change="onChange" mode="single" :placeholder="getLabel()" noResultsText="Результатов не найдено" :searchable="true" :close-on-select="true" :options="getValues()" :trackBy="'title'" :max="1">
      <template v-slot:singlelabel="{ value }">
        <div class="multiselect-single-label option-item">
          <div class="item-image-wrap" v-if="value.image">
            <img class="item-image" :src="value.image">
          </div>
          <div class="item-name"> {{ value.title }}</div>
        </div>
      </template>
      <template v-slot:option="{ option }">
        <div class="option-item">
          <div class="item-image-wrap" v-if="option.image">
            <img class="item-image" :src="option.image">
          </div>
          <div class="item-name"> {{ option.title }}
            <div class="item-path">
              <span class="item-level" :class="'level-' + option.level"></span>
              {{ option.path }}
            </div>
          </div>
        </div>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, reactive, ref} from "vue"
import Multiselect from "@/plugins/multiselect"

export default defineComponent({
  name: "Select",
  components: {
    Multiselect,
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    let val = ref(null)

    const payload = reactive({
      items: [],
      label: "",
      category_id: null,
    })

    onMounted(() => {
      updatePayload(props.payload)

      let categoryId = getCategoryIdPayload()

      if (categoryId !== null && categoryId !== undefined) {
        val.value = categoryId
        pushParent(categoryId)
      }
    })

    function updatePayload(query) {
      payload.items = query.items
      payload.label = query.label
      payload.category_id = query.category_id
    }

    function getCategoryIdPayload() {
      return payload.category_id
    }

    function onChange(value) {
      pushParent(value)
    }

    function getValues() {
      return payload.items
    }

    function getLabel() {
      return payload.label
    }

    function pushParent(value) {
      emit("changeVal", {
        category_id: value,
      })
    }

    return {
      onChange,
      getValues,
      val,
      getLabel,
    }
  }
})
</script>
